<div class="back-navigator">
  <div class="button" (click)="onBackButtonClicked()"><span class="fa fa-chevron-left"></span></div>
  <div class="title" (click)="onBackButtonClicked()">{{ title }}</div>
</div>
